/**
 * Freedom Cart Count - Global cart count updater
 * Updates the Freedom cart count badge in the header
 * Works across all pages (product, collection, cart, etc.)
 */

(function() {
  'use strict';

  // Update Freedom cart count
  function updateFreedomCartCount(count) {
    const countStr = String(count);
    const targets = document.querySelectorAll('[data-freedom-cart-count]');
    
    targets.forEach(el => {
      if (count > 0) {
        el.textContent = countStr;
        el.style.display = 'inline-block';
        el.style.visibility = 'visible';
        el.style.opacity = '1';
      } else {
        el.style.display = 'none';
      }
    });
  }

  // Fetch cart and update count
  function updateCartCountFromAPI() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const count = cart.item_count || 0;
        updateFreedomCartCount(count);
      })
      .catch(() => {
        // Silently fail
      });
  }

  // Listen for cart updates
  document.addEventListener('cart:updated', function() {
    updateCartCountFromAPI();
  });

  // Initial update on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCartCountFromAPI);
  } else {
    updateCartCountFromAPI();
  }

  // Expose function globally for other scripts
  window.updateFreedomCartCount = updateFreedomCartCount;
})();

